import { render, staticRenderFns } from "./EncuestaTutoria.vue?vue&type=template&id=4b72861d&"
import script from "./EncuestaTutoria.vue?vue&type=script&lang=js&"
export * from "./EncuestaTutoria.vue?vue&type=script&lang=js&"
import style0 from "./EncuestaTutoria.vue?vue&type=style&index=0&id=4b72861d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports